// Configuración centralizada de la API
// Detectar si estamos en HTTPS (usa proxy) o HTTP (usa IP directa)
const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
const baseUrl = isHttps ? '' : 'http://88.148.15.138:7200';

export const API_CONFIG = {
  BASE_URL: baseUrl,
  ENDPOINTS: {
    LOGIN: '/api/login',
    CATEGORIAS: '/api/categorias',
    ALTA: '/api/alta',
    ALUMNOS: '/api/alumnos'
  }
};

export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
